<template>
  <div class="houseInfo">
      <div class="div">
        <p @click="refresh" class="p2">获取房产</p>
      </div>
       <p id="p1">房产列表：</p>
        <div class="fang-list">
            <!--<p id="p1">房产列表：</p>-->
            <ul>
              <li v-for="item in houseInfos" :key="item.index">
                <p>{{item.name}}</p>
              </li>
            </ul>
          </div>
    <!--<div v-if="homeUrl==='checkTelBeiDaZiYuan'">-->
      <!--<input @click="sub" type="button" class="commit" value="确定">-->
    <!--</div>-->
    <div class="beiZhu">
      <p>备注：</p>
      <p>若房产列表为空，请点击右上角【同步】以获得该手机号对应的房屋信息；</p>
      <p>若点击【获取】后房产列表仍未空，则有2个方法解决：</p>
      <p>1、【我的】-->【手机号】中绑定新的手机号</p>
      <p>2、联系物业公司前台，由物业人员更新您的手机号</p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      houseInfos: [],
      homeUrl:''
    }
  },
  mounted () {
    let vm = this
    vm.houseinfo()
  },
  methods: {
    houseinfo () {
      const _this = this
      if(sessionStorage.getItem('id')){
        _this.postRequest('house/queryByUserId', {
          userId: sessionStorage.getItem('id')
        },function (data) {
          _this.houseInfos = data
        })
      }
    },
    refresh () {
      const _this = this
      _this.postRequest('house/queryAndSaveByPhone',{},function (data) {
        alert('刷新成功')
        _this.houseInfos = data
      })
    },
    // sub(){
    //   // let url = sessionStorage.getItem('urlBeiDaZiYuan')
    //   const that = this ;
    //   that.homeUrl = sessionStorage.getItem('action') ||  sessionStorage.getItem('homePage') || sessionStorage.getItem('home');
    //   if(that.homeUrl ==='checkTelBeiDaZiYuan'){
    //     this.$router.push({name: 'homePageBeiDaZiYuan'})
    //   }
    //
    //
    // }
  }
}
</script>
<style scoped>
  .commit {
    width:580px;
    height:100px;
    border-radius:50px;
    color: #fff;
    font-size:32px;
    letter-spacing: 20px;
    margin-top: 50px;
    background: #d70b19;
  }
  .beiZhu{
    margin-top: 80px;
    padding: 0 30px;
  }
  .beiZhu p{
    color:rgba(204,204,204,1);
    line-height: 34px;
    text-align: left;
  }
.houseInfo{
    width: 100%;
    height: 100%;
    background-color: #fff;
}
.houseInfo ul li{
    font-size: 28px;
    padding: 30px 0;
    box-sizing: border-box;
    color:#333;
    text-align: left;
    margin-left: 30px;
  border-bottom: 1px solid #ECECEC;
}
.houseInfo .div {
  overflow: hidden;
  zoom: 1;
  font-size: 30px;
  padding: 48px 0;
}
.houseInfo .div .p2{
  float: right;
  color: #1B82D1;
  width:184px;
  height:56px;
  line-height: 56px;
  font-size:30px;
  color:rgba(247,185,50,1);
  background:rgba(255,255,255,1);
  box-shadow:6px 4px 10px rgba(177,177,177,0.25);
  border-radius: 50px 0 0 50px;
}
.fang-list{
  margin: 0 22px;
  box-sizing: border-box;
  background:rgba(255,255,255,1);
  border-radius:10px;
  box-shadow:8px 4px 14px 8px rgba(228,228,228,.28);
}
.houseInfo>p{
    font-size: 34px;
    text-align: left;
    line-height: 70px;
    font-weight: 600;
    padding-left: 22px;
    margin-bottom: 20px;
    color:#333333;
}
</style>



// WEBPACK FOOTER //
// src/components/pub-component/my/houseInfo.vue